import React from 'react';
import { COLORS, FONTS, META } from '../../globalStyles';
import { styles as doc } from '../documentPage/styles';

// Typography for a rendered LegalDocument body. Shared by /legal and /privacy, so a change to
// the heading rule or the bullet motif lands on both.
//
// The treatment mirrors what public/privacy.html used to do by hand, which is what these
// documents replaced.
export const styles: Record<string, React.CSSProperties> = {

  paragraph: doc.paragraph,
  link: doc.link,
  effective: {
    ...META,
    fontSize: '0.66rem',
    color: COLORS.faint,
    margin: '0 0 1.75rem 0',
  },
  intro: {
    fontFamily: FONTS.body,
    fontSize: '1.0625rem',
    lineHeight: 1.75,
    color: COLORS.muted,
    margin: '0 0 1rem 0',
  },
  heading: {
    fontFamily: FONTS.display,
    fontStretch: '125%',
    fontWeight: 600,
    fontSize: '1.15rem',
    letterSpacing: '-0.01em',
    lineHeight: 1.3,
    color: COLORS.text,
    margin: '2.75rem 0 0.85rem 0',
    paddingTop: '2.75rem',
    borderTop: `1px solid ${COLORS.border}`,
  },
  // The first section sits directly under the intro, so it drops the rule that separates
  // every later section from the one above it.
  headingFirst: {
    marginTop: '2rem',
    paddingTop: 0,
    borderTop: 'none',
  },
  subheading: {
    fontFamily: FONTS.body,
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.5,
    color: COLORS.text,
    margin: '1.75rem 0 0.6rem 0',
  },
  list: {
    listStyle: 'none',
    margin: '0 0 1rem 0',
    padding: 0,
  },
  // The diamond bullet is a rotated square positioned in the left gutter — the same motif as
  // the logo, and the same treatment public/privacy.html uses.
  listItem: {
    fontFamily: FONTS.body,
    fontSize: '1rem',
    lineHeight: 1.75,
    color: COLORS.muted,
    position: 'relative',
    paddingLeft: '1.25rem',
    marginBottom: '0.85rem',
  },
  bullet: {
    position: 'absolute',
    left: 0,
    top: '0.72em',
    width: '5px',
    height: '5px',
    background: COLORS.accent,
    transform: 'rotate(45deg)',
  },
  strong: {
    color: COLORS.text,
    fontWeight: 600,
  },
};
